import { Link } from "react-router-dom";
import { stats } from "@/mocks/members";

const anchors = [
  { href: "#hot", label: "今日热榜", icon: "ri-fire-line" },
  { href: "#categories", label: "话题分类", icon: "ri-layout-grid-line" },
  { href: "#featured", label: "精选瓜田", icon: "ri-bookmark-3-line" },
  { href: "#wall", label: "评论区热聊", icon: "ri-chat-quote-line" },
  { href: "#faq", label: "常见问题", icon: "ri-question-line" },
];

export default function Hero() {
  return (
    <section className="relative flex min-h-[640px] w-full items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=night%20city%20skyline%20with%20warm%20neon%20signs%20and%20abstract%20bokeh%20lights%2C%20rain%20wet%20street%20reflections%2C%20deep%20dark%20cinematic%20atmosphere%2C%20amber%20and%20coral%20glow%2C%20moody%20editorial%20photograph%2C%20high%20detail&width=1600&height=900&seq=yc-hero-01&orientation=landscape"
        alt="深夜城市霓虹与热闹的夜生活场景，象征深夜吃瓜社区氛围"
        title="深夜吃瓜 - 深夜话题讨论圈"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/80 via-background-950/70 to-background-950/95" />
      <div
        className="yc-glow pointer-events-none absolute -left-20 top-1/3 h-72 w-72 rounded-full bg-primary-500/25 blur-3xl"
        aria-hidden="true"
      />
      <div
        className="yc-glow pointer-events-none absolute -right-10 bottom-10 h-64 w-64 rounded-full bg-accent-500/20 blur-3xl"
        aria-hidden="true"
      />

      <div className="relative z-10 mx-auto w-full max-w-content px-4 pb-14 pt-28 md:px-6 md:pb-20 md:pt-32">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-500/40 bg-accent-500/10 px-3.5 py-1.5 text-xs text-accent-500">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-400 opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-500" />
            </span>
            今晚已有 8.4 万人一起在线吃瓜
          </span>

          <h1 className="heading-serif mt-6 text-4xl font-black leading-[1.15] text-foreground-950 md:text-6xl">
            深夜吃瓜，
            <br />
            <span className="text-primary-500">每个热门瓜都有专属讨论圈</span>
          </h1>

          <p className="mt-6 max-w-2xl text-base leading-relaxed text-foreground-300 md:text-lg">
            汇集评论区热聊、观点碰撞与互动交流。先看完整的来龙去脉，再围观别人怎么想，最后说出你的判断 —— 感受深夜吃瓜的集体狂欢。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/topics"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
            >
              <i className="ri-chat-new-line text-base" />
              进入话题广场
            </Link>
            <Link
              to="/rank"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300/60 bg-background-950/40 px-6 py-3 text-sm text-foreground-100 backdrop-blur transition-colors hover:border-accent-500 hover:text-accent-500"
            >
              <i className="ri-fire-line text-base" />
              看看今晚热榜
            </Link>
          </div>

          <div className="mt-10 flex flex-wrap gap-2">
            {anchors.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="flex items-center gap-1.5 whitespace-nowrap rounded-full border border-background-300/40 bg-background-950/30 px-3.5 py-1.5 text-xs text-foreground-200 backdrop-blur transition-colors hover:border-primary-500/60 hover:text-primary-400"
              >
                <i className={item.icon} />
                {item.label}
              </a>
            ))}
          </div>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-5">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-background-300/30 bg-background-950/40 px-4 py-4 backdrop-blur md:px-5 md:py-5"
            >
              <div className="flex items-center gap-2 text-accent-500">
                <i className={`${stat.icon} text-lg`} />
                <span className="text-xs text-foreground-400">{stat.label}</span>
              </div>
              <p className="brand-font mt-2 text-2xl text-foreground-950 md:text-3xl">{stat.value}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}